import { getDeviceId, storeToken } from './license';

const PLAY = 'https://play.google.com/billing';
const API = `${process.env.REACT_APP_BACKEND_URL}/api/play/verify`;
export const PLAY_PRODUCTS = [
  { sku: 'giss_komplett_yearly', pack: 'ALL', key: 'playAll' },
];

let svc;
// Digital Goods API is only present inside the Play Store TWA build
export async function playService() {
  if (svc !== undefined) return svc;
  try { svc = 'getDigitalGoodsService' in window ? await window.getDigitalGoodsService(PLAY) : null; } catch { svc = null; }
  return svc;
}

export async function playPrices() {
  const s = await playService();
  if (!s) return {};
  try {
    const items = await s.getDetails(PLAY_PRODUCTS.map((p) => p.sku));
    return Object.fromEntries(items.map((i) => [i.itemId, new Intl.NumberFormat(undefined, { style: 'currency', currency: i.price.currency }).format(i.price.value)]));
  } catch { return {}; }
}

async function post(sku, purchaseToken, transfer) {
  const res = await fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ device_id: getDeviceId(), sku, purchase_token: purchaseToken, transfer }) });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || 'play_invalid');
  return storeToken(data.token);
}
// subscription bound to another device -> ask to move it here (old device gets locked)
async function verify(sku, purchaseToken, askTransfer) {
  try { return await post(sku, purchaseToken, false); } catch (e) {
    if (e.message !== 'play_bound' || !askTransfer || !(await askTransfer())) throw e;
    return post(sku, purchaseToken, true);
  }
}

export async function playBuy(sku, askTransfer) {
  if (!(await playService())) throw new Error('play_unavailable');
  const req = new PaymentRequest([{ supportedMethods: PLAY, data: { sku } }], { total: { label: 'Total', amount: { currency: 'EUR', value: '0' } } });
  const resp = await req.show();
  try {
    const lic = await verify(sku, resp.details.purchaseToken, askTransfer);
    await resp.complete('success');
    return lic;
  } catch (e) { await resp.complete('fail'); throw e; }
}

export async function playRestore(askTransfer) {
  const s = await playService();
  if (!s) throw new Error('play_unavailable');
  const list = await s.listPurchases();
  const out = [];
  let err = null;
  for (const p of list) if (PLAY_PRODUCTS.some((x) => x.sku === p.itemId)) { try { out.push(await verify(p.itemId, p.purchaseToken, askTransfer)); } catch (e) { err = e; } }
  if (!out.length && err && ['play_bound', 'play_switch_limit'].includes(err.message)) throw err;
  return out;
}
